export default __webpack_public_path__ + "static/media/userImg01.e42785a4.png";